import { defineStore } from 'pinia'
import authApi from '@/api/authApi.js'
import { wsMessages } from '@/services/wsMessages.js'


const ACCESS_KEY = 'auth_access'
const REFRESH_KEY = 'auth_refresh'

export const useAuthStore = defineStore('authStore', {
    state: () => ({
        access: null,
        refresh: null,
        me: null,
        loading: false,
        error: null,
    }),
    getters: {
        isAuthenticated: (s) => !!s.me?.id,
    },
    actions: {
        _persistTokens({ access, refresh }) {
            if (access) localStorage.setItem(ACCESS_KEY, access)
            if (refresh) localStorage.setItem(REFRESH_KEY, refresh)
            this.access = access ?? this.access
            this.refresh = refresh ?? this.refresh
        },
        _clearTokens() {
            localStorage.removeItem(ACCESS_KEY)
            localStorage.removeItem(REFRESH_KEY)
            this.access = null
            this.refresh = null
        },
        loadTokensFromStorage() {
            this.access = localStorage.getItem(ACCESS_KEY)
            this.refresh = localStorage.getItem(REFRESH_KEY)
        },
        async login({ username, email, password }) {
            this.loading = true
            this.error = null
            try {
                // В зависимости от бэка используйте username или email: backend принимает одно из полей
                const creds = email ? { email, password } : { username, password }
                const tok = await authApi.obtainToken(creds)
                this._persistTokens({ access: tok?.access, refresh: tok?.refresh })
                // подтянем профиль
                this.me = await authApi.getMe()
                return this.me
            } catch (e) {
                this.error = e
                this._clearTokens()
                this.me = null
                throw e
            } finally {
                this.loading = false
            }
        },
        async refreshAccess() {
            const storedRefresh = this.refresh || localStorage.getItem(REFRESH_KEY)
            if (!storedRefresh) throw new Error('No refresh token')
            // Не делаем logout здесь - это делает http interceptor
            const { access } = await authApi.refreshToken(storedRefresh)
            this._persistTokens({ access })
            return access
        },
        async loadMe() {
            try {
                this.me = await authApi.getMe()
                return this.me
            } catch (e) {
                this.me = null
                throw e
            }
        },
        async requestPasswordReset(email) {
            return authApi.requestPasswordReset(email)
        },
        async resetPasswordConfirm({ uid, token, new_password, re_new_password }) {
            return authApi.resetPasswordConfirm({ uid, token, new_password, re_new_password })
        },

        async logout() {
            this._clearTokens()
            this.me = null
            this.error = null
            try { wsMessages.close() } catch {}
            try { window.dispatchEvent(new CustomEvent('auth:logout')) } catch {}
        },
    }
})